/** The "what do you need" form, shared by the public page and the company/startup dashboards. */
import { html } from '../../core/html.js';
import { BUDGET_TYPES, CATEGORIES, ENGAGEMENT_TYPES, EXPERIENCE, LOCATIONS, WORK_MODES } from '../../core/constants.js';
import { field, radioField, tagField } from '../../ui/forms.js';

export function requirementFields({ prefix = 'rq', contact = false, values = {} } = {}) {
  const id = (name) => `${prefix}-${name}`;
  return html`
    ${contact ? html`<div class="fgrid">
      ${field(id('org'), 'Company or startup', { name: 'org_name', minlen: 2, autocomplete: 'organization' })}
      ${field(id('contact'), 'Your name', { name: 'contact_name', minlen: 2, autocomplete: 'name' })}
      ${field(id('email'), 'Work email', { type: 'email', name: 'contact_email', autocomplete: 'email' })}
      ${field(id('phone'), 'Phone', { type: 'tel', name: 'contact_phone', req: false })}
    </div>` : ''}
    ${field(id('title'), 'Role or project title', { name: 'title', minlen: 3, ph: 'Junior QA engineer', val: values.title })}
    ${radioField('type', 'Type of engagement', ENGAGEMENT_TYPES, values.type)}
    <div class="fgrid">
      ${field(id('category'), 'Category', { name: 'category', opts: CATEGORIES, val: values.category, req: false })}
      ${field(id('experience'), 'Experience level', { name: 'experience', opts: EXPERIENCE, val: values.experience, req: false })}
      ${field(id('count'), 'How many people', { type: 'number', name: 'count', min: 1, max: 500, val: values.count ?? 1, err: 'Enter a number from 1 to 500.' })}
      ${field(id('location'), 'Location', { name: 'location', opts: LOCATIONS, val: values.location, req: false })}
    </div>
    ${tagField(id('skills'), 'Skills needed', { name: 'skills', preset: values.skills || [] })}
    <div class="fgrid">
      ${field(id('budget-type'), 'Budget type', { name: 'budget_type', opts: BUDGET_TYPES, val: values.budget_type, req: false })}
      ${field(id('budget'), 'Budget', { name: 'budget_text', ph: '₹3.5 to 5 LPA', req: false, maxlength: 60, val: values.budget_text })}
    </div>
    ${radioField('work_mode', 'Work mode', WORK_MODES, values.work_mode, 'Choose a work mode.')}
    ${field(id('start'), 'Needed from', { type: 'date', name: 'start_by', req: false, val: values.start_by })}
    ${field(id('description'), 'Anything else we should know', { name: 'description', rows: 4, req: false, max: 5000, val: values.description, ph: 'Team size, tools, interview process' })}`;
}

/** Turn readForm() output into the API body: numbers as numbers, empty optional strings dropped. */
export function requirementBody(values) {
  const body = {};
  for (const [key, value] of Object.entries(values)) {
    if (value === '' || value == null) continue;
    body[key] = value;
  }
  body.count = Number(values.count) || 1;
  return body;
}
